export default __webpack_public_path__ + "static/video_poster_with_play-47f40d3025814aea82ccd973ed3785be.jpg";